import { Component, EventEmitter, ElementRef, Input, Output, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { bbGenerateShortId } from '../../../shared/utils/bbGenerateShortId.util';

export interface BbIconListOption {
	label: string;
	value: string;
	icon: string;
	svgIcon?: any;
	iconText?: string;
	checked?: boolean;
}
@Component({
	selector: 'bb-icon-list',
	templateUrl: './bb-icon-list.component.html',
	styleUrls: ['./bb-icon-list.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbIconListComponent),
		multi: true
	}]
})

export class BbIconListComponent implements ControlValueAccessor, OnInit, OnChanges {
	@Input() options: BbIconListOption[];
	@Input() actionOnly = false;
	@Input() useImages = false;
	@Input() useOpacity = false;
	@Input() showMoLabels = false;
	@Input() extraMargins: number[];
	@Output() selected = new EventEmitter<BbIconListOption>();

	selectedOption: BbIconListOption;
	el: HTMLElement;
	propagateChange: any;
	id = bbGenerateShortId();
	valueOnlyModel = false;

	constructor(private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() { }

	ngOnChanges(changes: SimpleChanges) { }

	onOptionClicked(option: BbIconListOption) {
		this.selectedOption = option;
		this.selected.emit(option);
		if (this.propagateChange) {
			this.propagateChange(this.valueOnlyModel ? this.selectedOption.value : this.selectedOption);
		}

		if (this.actionOnly) {
			this.selectedOption = null;
		}
	}

	writeValue(value: BbIconListOption | string) {
		if (typeof value === 'string') {
			this.valueOnlyModel = true;
			this.selectedOption = this.options.find(option => option.value === value);
		} else {
			this.selectedOption = value;
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
